// extracted by mini-css-extract-plugin
module.exports = {"content":"OrderSelector_content__5qzu3","submitBtn":"OrderSelector_submitBtn__33rr5"};